<template>
    <div class="main theme-light">

        <div class="animated fadeIn container-fluid">

            <div v-if="loading">
                <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
            </div>
            <div>
                <div v-if="reportData" id="print-page-top">
                    <b-row>
                        <b-col md=1></b-col>
                        <b-col md=10>
                            <div>

                                <!-- 生長期預測 -->
                                <MonthlyGrowthPredict :user="userInfo"></MonthlyGrowthPredict>

                                <template v-if="reportData.type == 'monthly'">
                                    <!-- <Monthly-1-0 v-if="reportData.version == 1.0" :report_data="reportData" :user="userInfo" :timezone="timezone"></Monthly-1-0> -->
                                </template>
                              
                            </div>
                        </b-col>
                        <!-- <b-col md=1></b-col> -->
                    </b-row>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TestData from '@/testData/testData'
import axios from 'axios'
import AgriLoading from '@/views/components/AgriLoading'
// import Monthly_1_0 from '@/views/project/report/Monthly_1.0'
import MonthlyGrowthPredict from '@/views/project/report/Monthly_GrowthPredict'

export default {
    components: {
        AgriLoading,
        // 'Monthly-1-0': Monthly_1_0,
        MonthlyGrowthPredict,
    },
    data () {
        return {
            loading: false,
            timezone: 'Asia/Taipei',
            reportData: {},//undefined,
            userInfo: undefined,
            // Admin
            deIdentification: false,    // Admin 用的去識別化遮罩
            // Test
            useTestData: false,         // 開發期間使用測試資料用
        }
    },
    mounted ()
    {
        this.timezone = this.$tools.date.getTimezoneNow();

        if ( localStorage.token != undefined )
        {
            this.$store.dispatch('user/getUserProfile')
                .then(res => {
                    this.$toastr.i( this.$t('other.toastr_welcome') , this.$t('other.toastr_hi') + this.user_first_name);

                    // 使用者語言可能會覆蓋掉網址列指定的語言，所以此處要再次指定語言
                    if ( this.$route.query.lang != undefined )
                    {
                        let newLang = this.$route.query.lang
                        switch (newLang)
                        {
                            case 'zh-Hant-TW': break;
                            default: newLang = 'en'; break;
                        }
                        this.$i18n.locale = newLang;
                        localStorage.setItem('locale', newLang);
                        this.$store.commit('user/setLanguage', newLang)
                        // console.log( 'user: ' + localStorage.locale )
                    }
                })
                .catch(err => {})
        }

        // 報告連結的資料帶在 params url 內，網址上是看不到的
        // this.get_Report_Data( this.$route.params.url )
    },
    computed: {
        ...mapState({
            'user_admin': state => state.user.is_admin,
            'user_first_name': state => state.user.first_name,
        }),
    },
    methods: {

        get_Report_URL ()
        {
            let _report_hashID = undefined

            // 使用 id 串接報告 hashid 的話，正常顯示
            if ( this.$route.query.id != undefined )
            {
                _report_hashID = this.$route.query.id
                this.deIdentification = false
            }
            // 使用 ids 串接報告 hashid 的話，要將資料進行去識別化
            else if ( this.$route.query.ids != undefined )
            {
                _report_hashID = this.$route.query.ids
                this.deIdentification = true
            }


            if ( _report_hashID != undefined )
            {
                this.loading = true
                const options = {
                    method: 'GET',
                    url: this.$config.getAPI_URL('Get_Report_URL', { reportID: _report_hashID }),
                }
                this.$http(options)
                    .then(res => {
                        this.loading = false

                        this.get_Report_Data( res.data.url);
                        this.userInfo = res.data.user;

                    })
                    .catch(err => {
                        this.loading = false

                        this.$router.push({
                            name: 'Page404'
                        }) // 導向 404

                    })
            }

        },

        get_Report_Data (dataURL)
        {
            if ( this.useTestData )
            {
                // console.log( TestData.Report_Monthly_1_0 )
                this.reportData = TestData.Report_Monthly_1_0
            }
            else if ( dataURL != undefined )
            {
                this.loading = true

                axios.get( dataURL )
                .then( res => {

                    if ( this.deIdentification == true )
                    {
                        this.reportData = this.get_De_Identification_Data( res.data )
                    }
                    else
                    {
                        this.reportData = res.data
                    }
                    this.loading = false
                    // console.log( res.data )
                })
                .catch( err => {
                    this.loading = false

                })
            }
            else
            {
                this.get_Report_URL()
            }
        },

        // 對撈到的報告資料做簡單遮罩，去識別化
        get_De_Identification_Data (originalData)
        {
            let _de_identification = originalData
            
            
            return _de_identification
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
